// import FFormSubmitBtnMDP from "@/components/generic/FFormSubmitBtnMDP";
// import FFormDrawerMDP from "@/components/generic/form/FFormDrawerMDP";
// import { FFormChildMDP } from "@/components/generic/form/FFormMDP";
// import FCurrencyFieldMDP from "@/components/generic/form/field/FCurrencyFieldMDP";
// import FDateFieldMDP from "@/components/generic/form/field/FDateFieldMDP";
// import FTextareaMDP from "@/components/generic/form/field/FTextareaMDP";
// import FSelectDateFieldMDP from "@/components/generic/form/field/FDateSelectFieldMDP";



// export default class CollectPaymentPGDrawerFFromMDP extends FFormDrawerMDP {
//   childMDP: FFormChildMDP = new FFormChildMDP();
//   parent: any;
//   constructor(props: { isVisible: boolean; onClose: () => void; parent: any }) {
//     super({
//       title: "Collect(Payment Gateway)",
//       isVisible: props.isVisible,
//       myRefName: "",
//       onClose: props.onClose,
//     });
//     this.parent = props.parent;
//     this.addField(
//       new FCurrencyFieldMDP({
//         dataSelectorKey: "amount",
//         label: "Amount",
//         parentMDP: this.childMDP,
//         boundaryClass: "col-12",
//       })
//     )
//       .addField(
//         new FTextareaMDP({
//           dataSelectorKey: "remarks",
//           label: "Remarks",
//           parentMDP: this.childMDP,
//           boundaryClass: "col-12",
//         })
//       )
//       .addAction(
//         new FFormSubmitBtnMDP({
//           label: "Submit",
//           onClick: () => {
//             props.parent.collectThroughPG();
//           },
//         })
//       );
//   }
// }


import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";
import FFormDrawerMDP from "@/components/form/FFormDrawerMDP";
import { FFormChildMDP } from "@/components/form/FFormMDP";
import FCurrencyFieldMDP from "@/components/form/field/FCurrencyFieldMDP";
import FTextareaMDP from "@/components/form/field/FTextareaMDP";



export default class CollectPaymentPGDrawerFFormMDP extends FFormDrawerMDP {

  childMDP: FFormChildMDP = new FFormChildMDP();
  parent: any;

  constructor({isVisible, onClose, parent}: {isVisible: boolean, onClose: () => void, parent: any}){
    super({
      myRefName: "CollectPaymentPGDrawerFFormRef",
      title: "Collect Payment",
      isVisible, 
      onClose, 
    })
    this.parent = parent;

    this.addField(
      new FCurrencyFieldMDP({
        dataSelectorKey: "amount",
        label: "Amount",
        parentMDP: this.childMDP,
        boundaryClass: "col-12",
        mandatory: true
      })
    )
    .addField(
      new FTextareaMDP({
        dataSelectorKey: "remarks",
        label: "Remarks",
        parentMDP: this.childMDP,
        boundaryClass: "col-12",
      })
    )
    .addAction(
      new FFormSubmitBtnMDP({
        label: "Submit",
        onClick: () => {
          this.parent.collectPayment();
        },
      })
    );
  }
}